import store from "@/state/store";

export default [
  {
    path: "/",
    name: "default",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/dashboards/default"),
  },
  //home page
  {
    path: "/home",
    name: "home",
    component: () => import("./views/home/home"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  //conditions d'utilisation
  {
    path: "/conditions",
    name: "conditions",
    component: () => import("./views/home/conditions"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  //Mentions légales
  {
    path: "/mentions",
    name: "mentions",
    component: () => import("./views/home/mentions"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
   //A propos
   {
    path: "/propos",
    name: "Propos",
    component: () => import("./views/home/propos"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  //Nos services
  {
    path: "/nosservices",
    name: "NosServices",
    component: () => import("./views/home/nosServices"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("./views/account/register"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/reset/password",
    name: "Reset password",
    component: () => import("./views/account/reset-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/reset/password/:token",
    name: "New password",
    component: () => import("./views/account/new-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      //authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch("auth/logOut");
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login")
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom }
        );
      },
    },
  },
  {
    path: "/404",
    name: "404",
    component: require("./views/utility/404").default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: "*",
    redirect: "404",
  },
  {
    path: "/users",
    name: "users",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/settings/users/users"),
  },
  {
    path: "/source",
    name: "source",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/settings/sources/source"),
  },
  {
    path: "/users/:id",
    name: "Users Details",
    component: () => import("./views/settings/users/users-details"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/catalogs",
    name: "catalogs",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/catalogs/list"),
  },
  {
    path: "/folders",
    name: "folders",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/folders/list"),
  },
  {
    path: "/folders/:id",
    name: "catalogs details",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/folders/details"),
  },
  {
    path: "/folders/:id/proposal",
    name: "proposal create",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/proposals/create"),
  },
  {
    path: "/proposals",
    name: "proposals",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/proposals/list"),
  },
  {
    path: "/proposals/:id",
    name: "proposals details",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/proposals/details"),
  },
  {
    path: "/proposals/:id/edit",
    name: "proposal edit",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/proposals/edit"),
  },
  {
    path: "/source/add-source",
    name: "add-source",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/settings/sources/add-source"),
  },
  {
    path: "/source/:id/edit-source",
    name: "edit-source",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/settings/sources/edit-source"),
  },
  {
    path: "/gestion",
    name: "gestion-rgpd",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/settings/gestionRgpd/gestion-rgpd"),
  },
  {
    path: "/rgpd",
    name: "rgpd-user",
    component: () => import("./views/settings/gestionRgpd/rgpd-user"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
];
